import React from 'react';

function Navbar(props) {
    return (
        <div className="navbar">
            <div className="container">
                <div className="row">
                    <div className="col-12 navBox">
                        <p className="title">Islom Karimov nomidagi Toshkent Davlat Texnika Universiteti</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;